import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import parseAndFormat from "../../../../components/texts/parseAndFormat";
import parseToFloat from "../../../../components/texts/parseToFloat";
import {useAllocationOverviewStyles} from "../../../../common/styles/allocationStyles";

const useStyles = useAllocationOverviewStyles;

const tableHeadings = [
    "Fulfillment status",
    "Requirement",
    "Required volume",
    "Joint fulfillment IN",
    "Flexibility surplus IN",
    "Allocated (LE)",
    "Allocated (L15)",
    "Remaining volume",
];

// const tableRows = new Array(10).fill(tableRow);

interface Props {
    requirement_quantities: any;
}

interface OverViewParamProps {
    etanol: number;
    etanol_advanced: number;
    fame: number;
    fame_advanced: number;
    hvo_hro: number;
    hvo_hro_advanced: number;
    nafta: number;
    nafta_advanced: number;
    bio_gasoline: number;
    bio_gasoline_advanced: number;
    general_mandate: number;
    advanced_sub_mandate: number;
    above_mandate_req_by_cust: number;
    above_mandate_after_fulfill: number;
    out_joint_fulfillment: number;
    surplus_volumes: number;
}

interface OverViewReqVolParamProps {
    general_mandate: number;
    general_req_vol: number;
    general_rel_vol: number;
    advanced_sub_mandate: number;
    advanced_sub_req_vol: number;
    advanced_sub_rel_vol: number;
    gasoline_req_vol: number;
    gasoline_rel_vol: number;
    above_mandate_req_by_cust: number;
    etanol: number;
    etanol_advanced: number;
    nafta: number;
    nafta_advanced: number;
    bio_gasoline: number;
    bio_gasoline_advanced: number;
    fame: number;
    fame_advanced: number;
    hvo_hro: number;
    hvo_hro_advanced: number;
    above_mandate_after_fulfill: number;
    out_joint_fulfillment: number;
    surplus_volumes: number;
}

interface OverViewProps {
    req_vol: OverViewReqVolParamProps;
    joint_fulfill: OverViewParamProps;
    allocated_LE: OverViewParamProps;
    allocated_15: OverViewParamProps;
    surplus_from_offroad: OverViewParamProps;
    remaining_vol: OverViewParamProps;
}

interface OverviewTableProps {
    step: number;
    data: OverViewProps;
}

const OverviewTable: React.FC<OverviewTableProps> = ({
                                                         step,
                                                         data
                                                     }) => {
    const classes = useStyles();

    const getStatus = (remaining: any) => {
        if (remaining > 0) { return "Not Complete"; }
        if (remaining < 0) { return "Overallocated"; }
        return "Complete";
    };

    // @ts-ignore
    const getResult = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return ((parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0) || reqVol.toString() === "?")
            ? "Not relevant"
            : parseToFloat(remainingVol.toString()) > 0
                ? "NOT fulfilled"
                : parseToFloat(remainingVol.toString()) < 0
                    ? "Over-allocated"
                    : "Mandate fulfilled";
    };
    const setColor = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return ((parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0) || reqVol.toString() === "?")
            ? classes.white
            : parseToFloat(remainingVol.toString()) > 0 || isNaN(remainingVol)
                ? classes.red
                : parseToFloat(remainingVol.toString()) < 0
                    ? classes.yellow
                    : classes.darkGreen;
    };

    const setFuelColor = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0
            ? classes.white
            : parseToFloat(remainingVol.toString()) > 0
                ? classes.red
                : parseToFloat(remainingVol.toString()) < 0
                    ? classes.yellow
                    : classes.green;
    };
    // @ts-ignore
    const getFuelTypeResult = (reqVol: any, allocatedLE: any, remainingVol: any) => {
        if (isNaN(allocatedLE) && isNaN(remainingVol)) {
            allocatedLE = 0;
            remainingVol = parseToFloat(reqVol.toString()) - allocatedLE;
        }
        return parseToFloat(reqVol.toString()) + parseToFloat(allocatedLE.toString()) === 0
            ? "Not relevant"
            : parseToFloat(remainingVol.toString()) > 0
                ? "Sold vol. to be allocated"
                : parseToFloat(remainingVol.toString()) < 0
                    ? "Sold vol. over-allocated"
                    : "Completed";
    };

    // @ts-ignore
    return (
        <div className={classes.tableContainer}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        {tableHeadings.map((heading, hidx) => (
                            <TableCell key={hidx}>{heading}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {step > 0 && (
                        <TableRow
                            style={{
                                border: step === 2 || step === 1 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.advanced_sub_req_vol,
                                data.allocated_LE.advanced_sub_mandate,
                                data.remaining_vol.advanced_sub_mandate
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{getResult(
                                data.req_vol.advanced_sub_req_vol,
                                data.allocated_LE.advanced_sub_mandate,
                                data.remaining_vol.advanced_sub_mandate
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>Advanced sub-mandate ({data.req_vol.advanced_sub_mandate} %)</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{parseAndFormat(data.req_vol.advanced_sub_req_vol, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{parseAndFormat(data.joint_fulfill.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{parseAndFormat(data.surplus_from_offroad.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{parseAndFormat(data.allocated_LE.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{parseAndFormat(data.allocated_15.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 2 || step === 1 ? "bold" : "normal",
                                color: step === 2 || step === 1 ? "black" : "white",
                            }}>{parseAndFormat(data.remaining_vol.advanced_sub_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step > 2 && (
                        <TableRow
                            style={{
                                border: step === 3 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.general_req_vol,
                                data.allocated_LE.general_mandate,
                                data.remaining_vol.general_mandate
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{getResult(
                                data.req_vol.general_req_vol,
                                data.allocated_LE.general_mandate,
                                data.remaining_vol.general_mandate
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>General mandate ({data.req_vol.general_mandate}%)</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{parseAndFormat(data.req_vol.general_req_vol, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{parseAndFormat(data.joint_fulfill.general_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{parseAndFormat(data.surplus_from_offroad.general_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{parseAndFormat(data.allocated_LE.general_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{parseAndFormat(data.allocated_15.general_mandate, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 3 ? "bold" : "normal",
                                color: step === 3 ? "black" : "white",
                            }}>{parseAndFormat(data.remaining_vol.general_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step > 3 && (
                        <TableRow
                            style={{
                                border: step === 4 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_LE.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}
                        >
                            {(() => {
                                const result = getResult(
                                    data.req_vol.above_mandate_req_by_cust,
                                    data.allocated_LE.above_mandate_req_by_cust,
                                    data.remaining_vol.above_mandate_req_by_cust
                                );
                                return (
                                    <>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{result}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>Above the mandate (required by customers)</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{parseAndFormat(data.req_vol.above_mandate_req_by_cust, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{parseAndFormat(data.joint_fulfill.above_mandate_req_by_cust, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{parseAndFormat(data.surplus_from_offroad.above_mandate_req_by_cust, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{parseAndFormat(data.allocated_LE.above_mandate_req_by_cust, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{parseAndFormat(data.allocated_15.above_mandate_req_by_cust, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 4 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 4 ? "black" : "white")
                                        }}>{parseAndFormat(data.remaining_vol.above_mandate_req_by_cust, 2)}</TableCell>
                                    </>
                                );
                            })()}
                        </TableRow>
                    )}
                    {step > 4 && (
                        <TableRow
                            style={{
                                border: step === 5 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_LE.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}
                        >
                            {(() => {
                                const result = getResult(
                                    data.req_vol.out_joint_fulfillment,
                                    data.allocated_LE.out_joint_fulfillment,
                                    data.remaining_vol.out_joint_fulfillment
                                );
                                return (
                                    <>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{result}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>Joint fulfillment OUT</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{parseAndFormat(data.req_vol.out_joint_fulfillment, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{parseAndFormat(data.joint_fulfill.out_joint_fulfillment, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{parseAndFormat(data.surplus_from_offroad.out_joint_fulfillment, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{parseAndFormat(data.allocated_LE.out_joint_fulfillment, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{parseAndFormat(data.allocated_15.out_joint_fulfillment, 2)}</TableCell>
                                        <TableCell style={{
                                            fontWeight: step === 5 ? "bold" : "normal",
                                            color: result === "Not relevant" ? "grey" : (step === 5 ? "black" : "white")
                                        }}>{parseAndFormat(data.remaining_vol.out_joint_fulfillment, 2)}</TableCell>
                                    </>
                                );
                            })()}
                        </TableRow>
                    )}
                    {step > 5 && (
                        <TableRow
                            style={{
                                border: step === 6 ? "4px solid" : "1px solid",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_LE.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}
                        >
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{getResult(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_LE.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>Above the mandate (after mandate fulfillment)</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{parseAndFormat(data.req_vol.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{parseAndFormat(data.joint_fulfill.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{parseAndFormat(data.surplus_from_offroad.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{parseAndFormat(data.allocated_LE.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{parseAndFormat(data.allocated_15.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{
                                fontWeight: step === 6 ? "bold" : "normal",
                                color: step === 6 ? "black" : "white",
                            }}>{parseAndFormat(data.remaining_vol.above_mandate_after_fulfill, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step !== 1 && (
                        <>
                            {step !== 2 && (
                                <TableRow
                                    className={setFuelColor(
                                        data.req_vol.etanol,
                                        data.allocated_LE.etanol,
                                        data.remaining_vol.etanol
                                    )}
                                >
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{getFuelTypeResult(
                                        data.req_vol.etanol,
                                        data.allocated_LE.etanol,
                                        data.req_vol.etanol - data.allocated_LE.etanol
                                    )}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>Etanol</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.req_vol.etanol, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.joint_fulfill.etanol, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.surplus_from_offroad.etanol, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_LE.etanol, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_15.etanol, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.etanol,
                                            data.allocated_LE.etanol,
                                            data.remaining_vol.etanol
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.remaining_vol.etanol, 2)}</TableCell>
                                </TableRow>
                            )}
                            <TableRow
                                className={setFuelColor(
                                    data.req_vol.etanol_advanced,
                                    data.allocated_LE.etanol_advanced,
                                    data.remaining_vol.etanol_advanced
                                )}
                            >
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{getFuelTypeResult(
                                    data.req_vol.etanol_advanced,
                                    data.allocated_LE.etanol_advanced,
                                    data.req_vol.etanol_advanced - data.allocated_LE.etanol_advanced
                                )}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>Etanol (advanced)</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.req_vol.etanol_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.joint_fulfill.etanol_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.surplus_from_offroad.etanol_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_LE.etanol_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_15.etanol_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.etanol_advanced,
                                        data.allocated_LE.etanol_advanced,
                                        data.remaining_vol.etanol_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.remaining_vol.etanol_advanced, 2)}</TableCell>
                            </TableRow>
                            {step !== 2 && (
                                <TableRow
                                    className={setFuelColor(
                                        data.req_vol.nafta,
                                        data.allocated_LE.nafta,
                                        data.remaining_vol.nafta
                                    )}
                                >
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{getFuelTypeResult(
                                        data.req_vol.nafta,
                                        data.allocated_LE.nafta,
                                        data.req_vol.nafta - data.allocated_LE.nafta
                                    )}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>Nafta</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.req_vol.nafta, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.joint_fulfill.nafta, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.surplus_from_offroad.nafta, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_LE.nafta, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_15.nafta, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.nafta,
                                            data.allocated_LE.nafta,
                                            data.remaining_vol.nafta
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.remaining_vol.nafta, 2)}</TableCell>
                                </TableRow>
                            )}
                            <TableRow
                                className={setFuelColor(
                                    data.req_vol.nafta_advanced,
                                    data.allocated_LE.nafta_advanced,
                                    data.remaining_vol.nafta_advanced
                                )}
                            >
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{getFuelTypeResult(
                                    data.req_vol.nafta_advanced,
                                    data.allocated_LE.nafta_advanced,
                                    data.req_vol.nafta_advanced - data.allocated_LE.nafta_advanced
                                )}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>Nafta (advanced)</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.req_vol.nafta_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.joint_fulfill.nafta_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.surplus_from_offroad.nafta_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_LE.nafta_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_15.nafta_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.nafta_advanced,
                                        data.allocated_LE.nafta_advanced,
                                        data.remaining_vol.nafta_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.remaining_vol.nafta_advanced, 2)}</TableCell>
                            </TableRow>
                            {step !== 2 && (
                                <TableRow
                                    className={setFuelColor(
                                        data.req_vol.bio_gasoline,
                                        data.allocated_LE.bio_gasoline,
                                        data.remaining_vol.bio_gasoline
                                    )}
                                >
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{getFuelTypeResult(
                                        data.req_vol.bio_gasoline,
                                        data.allocated_LE.bio_gasoline,
                                        data.req_vol.bio_gasoline - data.allocated_LE.bio_gasoline
                                    )}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>Bio gasoline</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.req_vol.bio_gasoline, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.joint_fulfill.bio_gasoline, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.surplus_from_offroad.bio_gasoline, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_LE.bio_gasoline, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_15.bio_gasoline, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.bio_gasoline,
                                            data.allocated_LE.bio_gasoline,
                                            data.remaining_vol.bio_gasoline
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.remaining_vol.bio_gasoline, 2)}</TableCell>
                                </TableRow>
                            )}
                            <TableRow
                                className={setFuelColor(
                                    data.req_vol.bio_gasoline_advanced,
                                    data.allocated_LE.bio_gasoline_advanced,
                                    data.remaining_vol.bio_gasoline_advanced
                                )}
                            >
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{getFuelTypeResult(
                                    data.req_vol.bio_gasoline_advanced,
                                    data.allocated_LE.bio_gasoline_advanced,
                                    data.req_vol.bio_gasoline_advanced - data.allocated_LE.bio_gasoline_advanced
                                )}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>Bio gasoline (advanced)</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.req_vol.bio_gasoline_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.joint_fulfill.bio_gasoline_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.surplus_from_offroad.bio_gasoline_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_LE.bio_gasoline_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_15.bio_gasoline_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.bio_gasoline_advanced,
                                        data.allocated_LE.bio_gasoline_advanced,
                                        data.remaining_vol.bio_gasoline_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.remaining_vol.bio_gasoline_advanced, 2)}</TableCell>
                            </TableRow>
                            {step !== 2 && (
                                <TableRow
                                    className={setFuelColor(
                                        data.req_vol.fame,
                                        data.allocated_LE.fame,
                                        data.remaining_vol.fame
                                    )}
                                >
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{getFuelTypeResult(
                                        data.req_vol.fame,
                                        data.allocated_LE.fame,
                                        data.req_vol.fame - data.allocated_LE.fame
                                    )}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>FAME</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.req_vol.fame, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.joint_fulfill.fame, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.surplus_from_offroad.fame, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_LE.fame, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_15.fame, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.fame,
                                            data.allocated_LE.fame,
                                            data.remaining_vol.fame
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.remaining_vol.fame, 2)}</TableCell>
                                </TableRow>
                            )}
                            <TableRow
                                className={setFuelColor(
                                    data.req_vol.fame_advanced,
                                    data.allocated_LE.fame_advanced,
                                    data.remaining_vol.fame_advanced
                                )}
                            >
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{getFuelTypeResult(
                                    data.req_vol.fame_advanced,
                                    data.allocated_LE.fame_advanced,
                                    data.req_vol.fame_advanced - data.allocated_LE.fame_advanced
                                )}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>FAME (advanced)</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.req_vol.fame_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.joint_fulfill.fame_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.surplus_from_offroad.fame_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_LE.fame_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_15.fame_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.fame_advanced,
                                        data.allocated_LE.fame_advanced,
                                        data.remaining_vol.fame_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.remaining_vol.fame_advanced, 2)}</TableCell>
                            </TableRow>
                            {step !== 2 && (
                                <TableRow
                                    className={setFuelColor(
                                        data.req_vol.hvo_hro,
                                        data.allocated_LE.hvo_hro,
                                        data.remaining_vol.hvo_hro
                                    )}
                                >
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{getFuelTypeResult(
                                        data.req_vol.hvo_hro,
                                        data.allocated_LE.hvo_hro,
                                        data.req_vol.hvo_hro - data.allocated_LE.hvo_hro
                                    )}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>HVO/HRO</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.req_vol.hvo_hro, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.joint_fulfill.hvo_hro, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.surplus_from_offroad.hvo_hro, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_LE.hvo_hro, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.allocated_15.hvo_hro, 2)}</TableCell>
                                    <TableCell style={{
                                        color: getFuelTypeResult(
                                            data.req_vol.hvo_hro,
                                            data.allocated_LE.hvo_hro,
                                            data.remaining_vol.hvo_hro
                                        ) !== "Not relevant" ? "black" : "grey",
                                    }}>{parseAndFormat(data.remaining_vol.hvo_hro, 2)}</TableCell>
                                </TableRow>
                            )}
                            <TableRow
                                className={setFuelColor(
                                    data.req_vol.hvo_hro_advanced,
                                    data.allocated_LE.hvo_hro_advanced,
                                    data.remaining_vol.hvo_hro_advanced
                                )}
                            >
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{getFuelTypeResult(
                                    data.req_vol.hvo_hro_advanced,
                                    data.allocated_LE.hvo_hro_advanced,
                                    data.req_vol.hvo_hro_advanced - data.allocated_LE.hvo_hro_advanced
                                )}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>HVO/HRO (advanced)</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.req_vol.hvo_hro_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.joint_fulfill.hvo_hro_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.surplus_from_offroad.hvo_hro_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_LE.hvo_hro_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.allocated_15.hvo_hro_advanced, 2)}</TableCell>
                                <TableCell style={{
                                    color: getFuelTypeResult(
                                        data.req_vol.hvo_hro_advanced,
                                        data.allocated_LE.hvo_hro_advanced,
                                        data.remaining_vol.hvo_hro_advanced
                                    ) !== "Not relevant" ? "black" : "grey",
                                }}>{parseAndFormat(data.remaining_vol.hvo_hro_advanced, 2)}</TableCell>
                            </TableRow>
                        </>
                    )}
                    {step < 1 && (
                        <TableRow
                            style={{
                                borderTop: step === 0 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.advanced_sub_req_vol,
                                data.allocated_LE.advanced_sub_mandate,
                                data.remaining_vol.advanced_sub_mandate
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.advanced_sub_req_vol,
                                data.allocated_LE.advanced_sub_mandate,
                                data.remaining_vol.advanced_sub_mandate
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Advanced sub-mandate ({data.req_vol.advanced_sub_mandate} %)</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.advanced_sub_req_vol, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.surplus_from_offroad.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_LE.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.advanced_sub_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.advanced_sub_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 3 && (
                        <TableRow
                            style={{
                                borderTop: step === 2 || step === 1 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.general_req_vol,
                                data.allocated_LE.general_mandate,
                                data.remaining_vol.general_mandate
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.general_req_vol,
                                data.allocated_LE.general_mandate,
                                data.remaining_vol.general_mandate
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>General mandate ({data.req_vol.general_mandate} %)</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.general_req_vol, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.general_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.surplus_from_offroad.general_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_LE.general_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.general_mandate, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.general_mandate, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 4 && (
                        <TableRow
                            style={{
                                borderTop: step === 3 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_LE.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.above_mandate_req_by_cust,
                                data.allocated_LE.above_mandate_req_by_cust,
                                data.remaining_vol.above_mandate_req_by_cust
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Above the mandate (required by customers)</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.surplus_from_offroad.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_LE.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.above_mandate_req_by_cust, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.above_mandate_req_by_cust, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 5 && (
                        <TableRow
                            style={{
                                borderTop: step === 4 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_LE.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{getResult(
                                data.req_vol.out_joint_fulfillment,
                                data.allocated_LE.out_joint_fulfillment,
                                data.remaining_vol.out_joint_fulfillment
                            )}</TableCell>
                            <TableCell style={{ color: "grey", }}>Joint fulfillment OUT</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.req_vol.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.surplus_from_offroad.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_LE.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.out_joint_fulfillment, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.out_joint_fulfillment, 2)}</TableCell>
                        </TableRow>
                    )}
                    {step < 6 && (
                        <TableRow
                            style={{
                                borderTop: step === 5 ? "4px solid" : "1px solid",
                                color: "grey !important",
                            }}
                            className={setColor(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_LE.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            )}
                        >
                            <TableCell style={{ color: "grey", }}>{step === 2 ? "TBD" : (getResult(
                                data.req_vol.above_mandate_after_fulfill,
                                data.allocated_LE.above_mandate_after_fulfill,
                                data.remaining_vol.above_mandate_after_fulfill
                            ))}</TableCell>
                            <TableCell style={{ color: "grey", }}>Above the mandate (after mandate fulfillment)</TableCell>
                            <TableCell style={{ color: "grey", }}>{step === 2 ? "?" : parseAndFormat(data.req_vol.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.joint_fulfill.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.surplus_from_offroad.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_LE.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.allocated_15.above_mandate_after_fulfill, 2)}</TableCell>
                            <TableCell style={{ color: "grey", }}>{parseAndFormat(data.remaining_vol.above_mandate_after_fulfill, 2)}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>
    );
};

export default OverviewTable;
